/**
 * The per-page traffic concepts the watchdog screens share: potential_traffic and pivot, as defined
 * in the watchdog backlog item's potential-traffic.md and pivot.md.
 */
const DAYS_PER_MONTH = 30;

/** potential_traffic as sessions a month; undefined without Analytics. */
export const potentialMonthlyOf = (page) => (page.potentialTraffic == null ? undefined : page.potentialTraffic * DAYS_PER_MONTH);

export const POTENTIAL_HELP = "Estimated from the page's own past traffic, not measured: the 80th percentile of its daily organic sessions over the last 12 months, times 30. The days it was broken fall below that line, so a page with an issue shows what it can get when it works.";

const total = (values) => values.reduce((sum, value) => sum + value, 0);

/** The page's `key` over the window as a share of the site's, for the hover on its figure. A null day counts as none. */
export const siteShareOf = (spark, siteTraffic, key = "sessions", name = "organic sessions") => {
    const site = total(siteTraffic.map((day) => day[key] ?? 0));
    if (!spark || site === 0) return undefined;
    const percent = total(spark.map((value) => value ?? 0)) / site * 100;
    return `${percent < 0.1 ? "<0.1" : percent.toFixed(1)}% of the site's ${name} in the last 12 months`;
};

export const PIVOT_COLOR = "#c026d3";

export const TRAFFIC_LOST_HELP = "Estimated, not measured: the page's average daily organic sessions in the 30 days before the pivot minus the 30 days from it, times 30.";

export const PIVOT_HELP = "The day the page's daily organic sessions changed level, found with Pettitt's test over the last 12 months, with the average a day before and after it. Only changes with p under 0.05 and at least 20% of the level before count.";

export const formatPivotDay = (iso) => new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "2-digit" });
